<template>
	<div>
		<template v-for="(item, index) in list">
			<div class="row item a" @click="navDetail(item.question_id)">
				<div class="left">
					<div class="row cb answer-content">
						<div class="row user">
							<el-image :src="item.answer.avatar" class="avatar"></el-image>
							<div class="nickname">{{ item.answer.nickname }}</div>
							<div class="desc">回答了问题</div>
						</div>
						<div class="row cc finish" v-if="item.answer.is_accept == 1">被采纳</div>
					</div>
					<div class="col answer-main">
						<div class="text-ellipsis answer-title">{{ item.title }}</div>
						<div class="text-ellipsis-3 answer-text">回答内容：{{ item.answer.content }}</div>
					</div>
					<div class="row operate">
						<div class="row cc btn">
							<el-image :src="require('@/pc/assets/ask/5.png')" class="img"></el-image>
							<span>{{ item.answer.agree_num }} 点赞</span>
						</div>
						<div class="row cc btn">
							<el-image :src="require('@/pc/assets/ask/3.png')" class="img"></el-image>
							<span>{{ item.answer.reply_num }} 回复</span>
						</div>
						<div class="date">回答于 {{ item.answer.create_time_text }}</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		list: {
			type: Array,
			default: () => {
				return [];
			}
		}
	},
	data() {
		return {};
	},
	methods: {
		navDetail(id) {
			this.$router.push({
				path: '/ask/detail',
				query: { id }
			});
		}
	}
};
</script>

<style scoped lang="less">
@import './answer.less';
</style>
